import {Component, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-info-block,[app-info-block], .app-info-block',
  templateUrl: './info-block.component.html',
  styleUrls: ['./info-block.component.scss'],
  animations: [
    trigger('toggleContent',
            [
                state('close', style({
                    height: 0,
                    display: 'none',
                    opacity: 0,
                    transform: 'translateY(-100px)'
                })),
                state('open', style({
                    height: '*',
                    display: 'block',
                    opacity: 1,
                    transform: 'translateY(0px)'
                })),
                transition( 'close <=> open', [
                   animate(".5s")
                ])
            ])
  ]
})
export class InfoBlockComponent implements OnInit {
  @Input() blockTitle: string;

  state = 'close'; // open
  titleCss = '';

  constructor() { }

  ngOnInit() {

      // FAQ
      // $(".js-faq-q").on("click", e => {
      //     e.preventDefault();
      //     $(e.currentTarget).toggleClass("is-open");
      //     $(e.currentTarget).next(".js-faq-a").slideToggle();
      // });
  }

  onClickTitle(){
      if (this.state == 'close') {
          this.state = 'open' ;
          this.titleCss = 'is-open';
      } else {
          this.state = 'close';
          this.titleCss = '';
      }
  }
    onContentStart(event){
      //console.log("onContentStart", event);
    }
    onContentEnd(event){
      //console.log("onContentEnd", event);
    }
}
